import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { appendPathToClientUrl } from 'services/helpers/resolveApiBaseUrl';

const OldLogin = () => {
  const { authenticated } = useSelector((state: RootState) => state.Login);
  if (!authenticated) {
    const url = sessionStorage.getItem('url');
    const loginUrl = appendPathToClientUrl(
      process.env.REACT_APP_POS2U_LOGIN_URL,
      url || ''
    );
    if (process.env.NODE_ENV === 'development') {
      window.location.href = '/';
    } else {
      window.location.href = loginUrl;
    }
  }

  return false;
};
export default OldLogin;
